/* ============================================================================
   cl-pdp-gal.js — teller en miniaturen bij de productgalerij (Cecile Lavelle)

   Vervangt pdp-gallery.js. Wat daar goed aan was is hier gebleven: wachten tot
   Swiper klaar is, de kloon-dia's van de loop overslaan, klikken via
   slideToLoop en meelezen op realIndex. Dat is het lastige deel en dat was al
   opgelost.

   Wat eruit is: het uitrekenen van de staghoogte per product, en het per foto
   omzetten naar `cover`. Het ontwerp geeft de galerij een vaste kast van 488 px
   waarin élke foto heel blijft. Dat is geen smaakverschil: de catalogus mengt
   staande modefoto's, vierkante packshots en dingen die geen kleding zijn, en
   een uitsnede die op het ene product klopt snijdt bij het volgende dwars door
   het product heen. De hoogte staat daarom in cl-pdp.css en niet hier.

   De opmaak zit volledig in cl-pdp.css, dat uit de goedgekeurde mockup wordt
   gegenereerd. Dit bestand zet alleen klassen en tekst — géén stijl.

   Alle zichtbare tekst komt uit locales/, via data-attributen op de container.
   Een lege vertaling is een geldige vertaling: dan blijft de teller weg in
   plaats van dat er Engels doorheen komt.
   ============================================================================ */
(function () {
  'use strict';

  var POGINGEN = 40;   // ~10 seconden; daarna laadt Swiper toch niet meer

  function start() {
    var pogingen = 0;
    var klok = setInterval(function () {
      var kast = document.querySelector('.cl-pdp__gal.swiper');
      if (!kast || !kast.swiper) {
        if (++pogingen > POGINGEN) clearInterval(klok);
        return;
      }
      clearInterval(klok);
      bouw(kast, kast.swiper);
    }, 250);
  }

  function bouw(kast, swiper) {
    if (kast.getAttribute('data-cl-gal')) return;
    kast.setAttribute('data-cl-gal', '1');

    // De laatste échte dia heet óók 'swiper-slide-duplicate-prev' omdat zijn
    // kloon ernaast staat. Op deelreeks filteren gooide die er onterecht uit,
    // dus exact vergelijken.
    var dias = Array.prototype.slice.call(kast.querySelectorAll('.swiper-slide'))
      .filter(function (d) { return !d.classList.contains('swiper-slide-duplicate'); });
    if (dias.length < 2) return;

    var tellerVorm = kast.getAttribute('data-teller') || '';
    var miniLabel = kast.getAttribute('data-mini-label') || '';

    var teller = null;
    if (tellerVorm) {
      teller = document.createElement('span');
      teller.className = 'cl-pdp__tel';
      teller.setAttribute('aria-hidden', 'true');   // de miniaturen zeggen het al
      kast.appendChild(teller);
    }

    var strook = document.createElement('div');
    strook.className = 'cl-pdp cl-pdp__mini';

    dias.forEach(function (dia, i) {
      var foto = dia.querySelector('img');
      var knop = document.createElement('button');
      knop.type = 'button';
      if (miniLabel) knop.setAttribute('aria-label', vul(miniLabel, i + 1, dias.length));

      if (foto) {
        var bron = (foto.currentSrc || foto.src || '').replace(/(&|\?)width=\d+/, '$1width=160');
        var mini = document.createElement('img');
        mini.src = bron;
        mini.width = 56;
        mini.height = 70;
        mini.alt = '';
        // eager: op een echte telefoon blijven lazy miniaturen te lang grijs
        mini.loading = 'eager';
        mini.decoding = 'async';
        knop.appendChild(mini);
      } else {
        // video of 3D-model: geen foto om te tonen, wel een plek in de rij
        knop.className = 'cl-pdp__minileeg';
      }

      knop.addEventListener('click', function () {
        if (typeof swiper.slideToLoop === 'function') swiper.slideToLoop(i);
        else swiper.slideTo(i);
      });
      strook.appendChild(knop);
    });

    kast.insertAdjacentElement('afterend', strook);

    function lees() {
      var i = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
      if (teller) teller.textContent = vul(tellerVorm, i + 1, dias.length);

      var knoppen = strook.children;
      for (var k = 0; k < knoppen.length; k++) {
        knoppen[k].classList.toggle('aan', k === i);
        knoppen[k].setAttribute('aria-current', k === i ? 'true' : 'false');
      }
      inBeeld(strook, knoppen[i]);
    }

    swiper.on('slideChange', lees);
    lees();
  }

  // Geklemd scrollen, niet scrollIntoView: bij de laatste miniatuur vraagt
  // centreren een positie voorbij het einde, en dat geeft op iOS een
  // elastische stuiter die eruitziet als een gat in de rij.
  function inBeeld(strook, knop) {
    if (!knop) return;
    var k = knop.getBoundingClientRect();
    var s = strook.getBoundingClientRect();
    if (k.left >= s.left && k.right <= s.right) return;

    var doel = knop.offsetLeft - (strook.clientWidth - knop.offsetWidth) / 2;
    var max = strook.scrollWidth - strook.clientWidth;
    strook.scrollTo({ left: Math.max(0, Math.min(doel, max)), behavior: 'smooth' });
  }

  function vul(vorm, nu, totaal) {
    return vorm.replace('{nu}', nu).replace('{totaal}', totaal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
